module.exports = __webpack_public_path__ + "static/media/sopt11ru.58d03a1c.pdf";